import script from "./ListarCliente.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarCliente.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__